import { useAddMultipleToCart } from '@jetshop/core/hooks/useAddMultipleToCart';
import t from '@jetshop/intl';
import theme from '@jetshop/ui/utils/theme';
import React, { useState } from 'react';
import styled from 'react-emotion';
import addMultipleToCartMutation from '../../Cart/addMultipleToCart.gql';
import cartQuery from '../../Cart/CartQuery.gql';
import { OnAddToCart } from '../../ProductPage/AddToCart/AddToCartForm';

const BuyButton = styled('button')`
  background: ${theme('colors.buy')};
  text-transform: uppercase;
  font-family: 'Abel', sans-serif;
  font-size: 1.3rem;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
  color: white;
  padding: 0.5rem 1rem;
`;

export const SharedCartBuyAllButton = ({ products, quantities }) => {
  const [mutationCompleted, setMutationCompleted] = useState(false);

  const [addToCart, { loading: mutationLoading }] = useAddMultipleToCart(
    products.map((p, i) => ({ ...p, quantity: quantities[i] })),
    {
      addMultipleToCartMutation,
      cartQuery,
    },
    {
      onCompleted: () => setMutationCompleted(true),
    }
  );

  return (
    <>
      <OnAddToCart onClick={addToCart}>
        {(props) => (
          <BuyButton
            className={mutationCompleted ? 'completed' : undefined}
            disabled={mutationLoading}
            onClick={() => {
              addToCart();
              props.showTarget(true);
            }}
          >
            {mutationLoading
              ? t('Lägger i varukorgen...')
              : mutationCompleted
              ? t('Produkter tillagda')
              : t('Lägg alla produkter i varukorgen')}
          </BuyButton>
        )}
      </OnAddToCart>
    </>
  );
};
